import { FuseConfig } from '@fuse/types';

/**
 * Default Fuse Configuration
 *
 * You can edit these options to change the default options. All these options also can be changed per component
 * basis. See `app/main/pages/authentication/login/login.component.ts` constructor method to learn more
 * about changing these options per component basis.
 */
export const fuseConfig: FuseConfig = {
    layout          : {
        style    : 'horizontal-layout-1',
        width    : 'fullwidth',
        navbar   : {
            background: 'mat-grey-800-bg',
            folded    : false,
            hidden    : false,
            position  : 'top',
            variant   : 'vertical-style-1'
        },
        toolbar  : {
            background: 'mat-fuse-white-500-bg',
            hidden    : false,
            position  : 'above'
        },
        footer   : {
            background: 'mat-cyan-500-bg',
            hidden    : true,
            position  : 'above-fixed'
        },
        sidepanel: {
            hidden  : true,
            position: 'right'
        }
    },
    customScrollbars: true
};
